<template>
	<div class="custom-footer">
		<div class="footer-top">
			<div class="footer-top-content">
				<img class="logo" :src="setting.logo_footer || '../assets/images/home/logo.png'" />
				<div class="footer-link-box" v-if="setting.footer_link.c1">
					<div class="footer-link" v-for="(v, k) in setting.footer_link.c1" @click="go(v.url)">{{v.name}}</div>
				</div>
				<div class="footer-link-box" v-if="setting.footer_link.c2">
					<div class="footer-link" v-for="(v, k) in setting.footer_link.c2" @click="go(v.url)">{{v.name}}</div>
				</div>
				<div class="footer-link-box" v-if="setting.footer_link.c3">
					<div class="footer-link" v-for="(v, k) in setting.footer_link.c3" @click="go(v.url)">{{v.name}}</div>
				</div>
				<img v-if="!!setting.qr_code" class="qrcode" :src="setting.qr_code || '../assets/images/home/qr@2x.jpg'" />
			</div>
		</div>
		<a class="copyright-box" target="_blank" href="https://beian.miit.gov.cn" >{{setting.copyright}}</a>

	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex';
	export default {
		name: 'Footer',
		props: {

		},
		computed: {
			...mapState(["setting"]),
		},
		methods: {
			goBack() {
				this.$router.back()
			},
			go(url) {
				if(url.startsWith('http')) {
					window.open(url, '_blank')
					return
				}
				this.$router.push({
					path: url
				})
			}
		}
	}
</script>

<style scoped lang="scss">
	.custom-footer {
		height: 308px;
		width: 100%;
		background: #000000;
		text-align: center;
		.footer-top {
			height: 228px;
			background: #222222;

			.footer-top-content {
				width: 1170px;
				margin: 0 auto;
				display: flex;
				justify-content: space-between;
				align-items: center;
				height: 100%;

				.footer-link-box {
					height: 100%;

					.footer-link-title {
						margin-top: 40px;
						font-size: 18px;
						font-family: PingFang SC;
						font-weight: bold;
						color: #EDD4AC;
					}

					.footer-link {
						margin-top: 20px;
						font-size: 15px;
						font-family: PingFang SC;
						font-weight: 400;
						color: #DDDDDD;
						cursor: pointer;
					}
				}
			}

			.logo {
				width: 230px;
				height: 37px;
			}

			.qrcode {
				width: 140px;
				height: 140px;
			}
		}

		.copyright-box {
			height: 80px;
			text-align: center;
			line-height: 80px;
			font-size: 12px;
			font-family: PingFang SC;
			font-weight: 400;
			color: #FFFFFF;

		}
	}
</style>
